import { AccessibilityMessage } from "shared/ui/accessibility-info/AccessibilityInfo"

import { FloorTypename, ProductPositionTypename, RoomTypename } from "./Project"
import {
  CREATE_PROJECT,
  CREATE_PROJECT_CHILD,
  DELETE_PROJECT
} from "./ProjectMutations"

export const SHOW_ACCESSIBILITY_MESSAGE = "SHOW_ACCESSIBILITY_MESSAGE" as const
export const MOVE_PROJECT_CHILD = "MOVE_PROJECT_CHILD" as const

export type AppEventType =
  | typeof CREATE_PROJECT
  | typeof DELETE_PROJECT
  | typeof CREATE_PROJECT_CHILD
  | typeof SHOW_ACCESSIBILITY_MESSAGE
  | typeof MOVE_PROJECT_CHILD

export interface CreateProjectEventPayload {
  id: string
}

export interface DeleteProjectEventPayload {
  id: string
}

export interface CreateProjectChildEventPayload {
  id: string
  type:
    | typeof FloorTypename
    | typeof RoomTypename
    | typeof ProductPositionTypename
  projectID: string
  parentID: string
  parentType: string
}

export interface MoveProjectChildEventPayload {
  id: string
  type:
    | typeof FloorTypename
    | typeof RoomTypename
    | typeof ProductPositionTypename
  parentID: string
  parentType: string
  projectID: string
  position: number
}

export interface ShowAccessiblityMessageEventPayload {
  messages?: AccessibilityMessage | AccessibilityMessage[] | null
}

export type EventPayloadByEventType<T extends AppEventType> =
  T extends typeof CREATE_PROJECT
    ? CreateProjectEventPayload
    : T extends typeof DELETE_PROJECT
    ? DeleteProjectEventPayload
    : T extends typeof CREATE_PROJECT_CHILD
    ? CreateProjectChildEventPayload
    : T extends typeof MOVE_PROJECT_CHILD
    ? MoveProjectChildEventPayload
    : T extends typeof SHOW_ACCESSIBILITY_MESSAGE
    ? ShowAccessiblityMessageEventPayload
    : never

export type EventHandlerByEventType<T extends AppEventType> = (
  payload: EventPayloadByEventType<T>
) => void
